import React, { ReactNode } from 'react';
// import _ from 'lodash';
import moment from 'moment';

import {
  Row,
  Col,
  Badge,
} from 'react-bootstrap';
import styled from 'styled-components';

import { Image, List, Divider } from 'antd';

// Auth
// import { useAuthContext } from '../../../auth/use-auth-context.js';
// import { useRouter } from '../../../auth/auth-guard';

// import Select from '../../../../components/select/Select.tsx';

// Redux
import { useDispatch } from 'react-redux';
import { RootState, AppDispatch, useTypedSelector } from '../../../../utils/store.tsx';
import slice, { fields, useFormikContext, stringToHtmlTrim, findSettings, findSettingsItem, getAccountDocSettingVariables, getAccountDocSettingItem, getAccountDocSettingVariablesProformaInvoice, getAccountDocSettingItemProformaInvoice, prepareDateTime, proformaInvoiceStatusText, getTotal } from './slice.tsx';
import { StyledList, StyledTable } from '../printPreview/Preview.tsx';
import { isStandardService, setPricingsData, margePricingsData } from '../../slice.tsx';
import { totalFields } from '../billingJob/slice.tsx';
import { getFirstCustomerSite, getServiceItemIds } from '../../../manage/jobs/jobTypes/slice.tsx';
import jobFormBinDetailsServicesSlice from '../services/slice.tsx';

import { getCurrency, formatNumber, isNumeric, dateFormat, dateViewFormat } from '../../../../utils/utils.tsx';
import { AccountDocSettingVariables, ServiceType, ProformaInvoiceStatus } from '../../../../utils/enums.tsx';

// import { ReactComponent as XIcon } from "../../../../../v5/assets/icons/x.svg";

import DefaultNoPhoto from "../../../../../v5/assets/img/transparent.png";

// ----------------------------------------------------------------------

const StyledImageCol = styled(Col)`
    .ant-image {
        width: unset !important;
        max-height: 250px;
        max-width: 250px;
    }
`;

const StyledBadge = styled(Badge)`
    padding: 5px 10px;
    font-size: 11px !important;

    ${(props: any) => {
        if(props.status === ProformaInvoiceStatus.Sent){
            return 'background-color: var(--bs-yellow-500) !important;'
        } else if(props.status === ProformaInvoiceStatus.Accepted){
            return 'background-color: #8908B7 !important;'
        } else if(props.status === ProformaInvoiceStatus.Declined){
            return 'background-color: var(--bs-red-500) !important;'
        } else if(props.status === ProformaInvoiceStatus.Paid){
            return 'background-color: var(--bs-green-500) !important;'
        } else {
            return 'background-color: var(--bs-gray-600) !important;'
        }
    }}
`;

export const StyledTotal = styled(Row)`
    border-radius: 6px;
    border: 1px solid var(--bs-gray-300);

    > div:not(:last-child) {
        border-bottom: 1px solid var(--bs-gray-300);
    }

    > div {
        padding: 6px 8px;
    }
`;

const StyledButton = styled.span`
    background-color: var(--bs-blue-500);
    color: white;
    padding: 8px 32px;
    border-radius: 6px;
    font-size: 16px;
    font-weight: 500;
    display: inline-block;
`;

// ----------------------------------------------------------------------

const PreviewComponent = (props: any) => {
    // const { user }: any = useAuthContext();
    // const { userAccount } = user ?? {};
    // const someField = userAccount?.someField;

    // const router = useRouter();

    const { isLoading, show, form, accountBillingProfile } = useTypedSelector((state: RootState) => state.jobFormProformaInvoiceSlice);
    const dispatch = useDispatch<AppDispatch>();


    const [ proformaPricings, setProformaPricings ] = React.useState<any>([]);


    React.useEffect(() => {
        if(show){
            getPricings()
        }
    }, [show, form])
  
    
    const getPricings = () => {
        let noPricings = (form.proformaPricings && form.proformaPricings.length > 0) ? false : true;
    
        if(noPricings){
            let serviceItemIds: Array<any> = getServiceItemIds(form);
            if(serviceItemIds && serviceItemIds.length > 0 ){
                dispatch(jobFormBinDetailsServicesSlice.callDetailsServicesItemsApi(serviceItemIds.map((x) => x.serviceItemId), async (state: boolean, selectedServices: any) => {
                    if(state){
                        let arr = selectedServices.map((y: any) => {
                            let quantity = serviceItemIds.find((x) => x.serviceItemId === y.serviceItemId)?.quantity || 0;

                            return {
                                ...y,
                                binTypeName: y?.binType?.binTypeName,
                                wasteTypeName: y?.wasteType?.wasteTypeName,
                                quantity: quantity,
                            }
                        });
            
                        let proformaPricings: Array<any> = [];
                        if(arr && arr.length > 0){
                            arr.forEach((mainItem: any) => {
                                let order = serviceItemIds.find((x) => x.serviceItemId === mainItem.serviceItemId)?.order || 0;
                                let newPricings = setPricingsData(mainItem, [], order, false, 0);
                                proformaPricings = margePricingsData(proformaPricings, newPricings);
                            });
                        }
                        
                        setProformaPricings(proformaPricings);
                    } else {
                        setProformaPricings(form?.proformaPricings);
                    }
                }));
            } else {
                setProformaPricings(form?.proformaPricings);
            }
        } else {
            setProformaPricings(form?.proformaPricings);
        }
    }


    const { values, errors, setValues, setFieldValue, validateForm, handleSubmit }: any = useFormikContext();
  

    /* HEADER & FOOTER */
    const headerDefaultElements = () => {
        let logoSrc: any = getAccountDocSettingItem(
            accountBillingProfile,
            "StringCompanyLogo",
            AccountDocSettingVariables.String,
            DefaultNoPhoto
        ) || '';

        return <Row className='align-items-center'>
            <Col xs={true} className={'rich-text-parse-texts'}>
                {stringToHtmlTrim(
                    getAccountDocSettingItem(
                        accountBillingProfile,
                        "StringHeaderText",
                        AccountDocSettingVariables.String,
                        ""
                    )
                )}
            </Col>
            <StyledImageCol xs={'auto'}>
                <Image
                    preview={false}
                    width={250}
                    alt={'Company Logo'}
                    src={logoSrc}
                />
            </StyledImageCol>
        </Row>
    }
    const footerElements = () => {
        let canShow = getAccountDocSettingItemProformaInvoice(accountBillingProfile, "ShowDisclaimer", AccountDocSettingVariables.Show, false) ? true : false;

        if(canShow){
            return <Row className='align-items-center mt-64'>
                {/* <Col xs={12}><Divider /></Col> */}
                <Col xs={true} className={'rich-text-parse-texts'}>
                    {stringToHtmlTrim(
                        getAccountDocSettingItemProformaInvoice(
                            accountBillingProfile,
                            "StringDisclaimerText",
                            AccountDocSettingVariables.String,
                            ""
                        )
                    )}
                </Col>
            </Row>
        }
    }
    /* END HEADER & FOOTER */


    /* PAGES */
    const page1 = () => {
        let customerSite = getFirstCustomerSite(form);
        let jobDateTime = prepareDateTime(form);

        let dataSourceList: any = [
            {
                order: findSettingsItem(findSettings(getAccountDocSettingVariables(accountBillingProfile), 'ShowCustomerName'), null, 'sortOrder'),
                show: getAccountDocSettingItem(accountBillingProfile, "ShowCustomerName", AccountDocSettingVariables.Show, false),
                label: getAccountDocSettingItem(accountBillingProfile, "LabelCustomer_Name", AccountDocSettingVariables.Label, "Customer Name"),
                value: (form?.customer && form?.customer.customerName) ? form?.customer.customerName : '',
            },
            {
                order: findSettingsItem(findSettings(getAccountDocSettingVariables(accountBillingProfile), 'ShowCustomerAddress'), null, 'sortOrder'),
                show: getAccountDocSettingItem(accountBillingProfile, "ShowCustomerAddress", AccountDocSettingVariables.Show, false),
                label: getAccountDocSettingItem(accountBillingProfile, "LabelCustomer_Address", AccountDocSettingVariables.Label, "Customer Address"),
                value: (form?.customer && form?.customer.billingAddress) ? form?.customer.billingAddress : '',
            },
            {
                order: findSettingsItem(findSettings(getAccountDocSettingVariables(accountBillingProfile), 'ShowProjectSite'), null, 'sortOrder'),
                show: getAccountDocSettingItem(accountBillingProfile, "ShowProjectSite", AccountDocSettingVariables.Show, false),
                label: getAccountDocSettingItem(accountBillingProfile, "LabelProject_Site", AccountDocSettingVariables.Label, "Project Site"),
                value: (customerSite && customerSite?.address) ? customerSite?.address : '',
            },
            {
                order: findSettingsItem(findSettings(getAccountDocSettingVariables(accountBillingProfile), 'ShowJobType'), null, 'sortOrder'),
                show: getAccountDocSettingItem(accountBillingProfile, "ShowJobType", AccountDocSettingVariables.Show, false),
                label: getAccountDocSettingItem(accountBillingProfile, "LabelJob_Type", AccountDocSettingVariables.Label, "Job Type"),
                value: (form?.jobTemplate && form?.jobTemplate.jobTemplateName) ? form?.jobTemplate.jobTemplateName : '',
            },
            {
                order: 155,
                show: (jobDateTime && jobDateTime != '') ? true : false,
                label: "Job Date",
                value: jobDateTime,
            },
        ];
        dataSourceList = dataSourceList.sort((a: any, b: any) => a.order - b.order);



        /* STANDARD ITEMS */
        let dataSourceTableHeadStandard: any = [
            {
                order: 1, //findSettingsItem(findSettings(getAccountDocSettingVariables(accountBillingProfile), 'ShowStandardServicesBinType'), null, 'sortOrder'),
                show: getAccountDocSettingItem(accountBillingProfile, "ShowStandardServicesBinType", AccountDocSettingVariables.Show, false),
                value: 'Bin Type',
            },
            {
                order: 2, //findSettingsItem(findSettings(getAccountDocSettingVariables(accountBillingProfile), 'ShowStandardServicesWasteType'), null, 'sortOrder'),
                show: getAccountDocSettingItem(accountBillingProfile, "ShowStandardServicesWasteType", AccountDocSettingVariables.Show, false),
                value: 'Waste Type',
            },
            {
                order: 3, //findSettingsItem(findSettings(getAccountDocSettingVariables(accountBillingProfile), 'ShowStandardServicesQty'), null, 'sortOrder'),
                show: getAccountDocSettingItem(accountBillingProfile, "ShowStandardServicesQty", AccountDocSettingVariables.Show, false),
                value: 'Qty',
            },
            {
                order: 4, //findSettingsItem(findSettings(getAccountDocSettingVariables(accountBillingProfile), 'ShowStandardServicesRate'), null, 'sortOrder'),
                show: getAccountDocSettingItem(accountBillingProfile, "ShowStandardServicesRate", AccountDocSettingVariables.Show, false),
                value: 'Rate',
            },
            {
                order: 5, //findSettingsItem(findSettings(getAccountDocSettingVariables(accountBillingProfile), 'ShowStandardServicesPrice'), null, 'sortOrder'),
                show: getAccountDocSettingItem(accountBillingProfile, "ShowStandardServicesPrice", AccountDocSettingVariables.Show, false),
                value: 'Price',
            },
        ];
        dataSourceTableHeadStandard = dataSourceTableHeadStandard.sort((a: any, b: any) => a.order - b.order);

        let dataSourceTableBodyStandard: any = [];
        let standardItems = proformaPricings && (proformaPricings.filter((x: any) => isStandardService(x)).length > 0) ? proformaPricings.filter((x: any) => isStandardService(x)) : [];
        if(standardItems && standardItems.length > 0){
            standardItems.forEach((item: any) => {
                let dataSourceTableBodyRowStandard: any = [
                    {
                        order: 1, //findSettingsItem(findSettings(getAccountDocSettingVariables(accountBillingProfile), 'ShowStandardServicesBinType'), null, 'sortOrder'),
                        show: getAccountDocSettingItem(accountBillingProfile, "ShowStandardServicesBinType", AccountDocSettingVariables.Show, false),
                        value: item?.binType?.binTypeName,
                    },
                    {
                        order: 2, //findSettingsItem(findSettings(getAccountDocSettingVariables(accountBillingProfile), 'ShowStandardServicesWasteType'), null, 'sortOrder'),
                        show: getAccountDocSettingItem(accountBillingProfile, "ShowStandardServicesWasteType", AccountDocSettingVariables.Show, false),
                        value: item?.wasteType?.wasteTypeName,
                    },
                    {
                        order: 3, //findSettingsItem(findSettings(getAccountDocSettingVariables(accountBillingProfile), 'ShowStandardServicesQty'), null, 'sortOrder'),
                        show: getAccountDocSettingItem(accountBillingProfile, "ShowStandardServicesQty", AccountDocSettingVariables.Show, false),
                        value: item.quantity,
                    },
                    {
                        order: 4, //findSettingsItem(findSettings(getAccountDocSettingVariables(accountBillingProfile), 'ShowStandardServicesRate'), null, 'sortOrder'),
                        show: getAccountDocSettingItem(accountBillingProfile, "ShowStandardServicesRate", AccountDocSettingVariables.Show, false),
                        value: getCurrency() + formatNumber(item?.price),
                    },
                    {
                        order: 5, //findSettingsItem(findSettings(getAccountDocSettingVariables(accountBillingProfile), 'ShowStandardServicesPrice'), null, 'sortOrder'),
                        show: getAccountDocSettingItem(accountBillingProfile, "ShowStandardServicesPrice", AccountDocSettingVariables.Show, false),
                        value: getCurrency() + formatNumber((item?.quantity * item?.price)),
                    },
                ];
                dataSourceTableBodyRowStandard = dataSourceTableBodyRowStandard.sort((a: any, b: any) => a.order - b.order);
                dataSourceTableBodyStandard.push(dataSourceTableBodyRowStandard);
            });
        }
        /* END STANDARD ITEMS */



        /* ADDITIONAL ITEMS */
        let dataSourceTableHeadAdditional: any = [
            {
                order: 1, //findSettingsItem(findSettings(getAccountDocSettingVariables(accountBillingProfile), 'ShowAdditionalServicesDescription'), null, 'sortOrder'),
                show: getAccountDocSettingItem(accountBillingProfile, "ShowAdditionalServicesDescription", AccountDocSettingVariables.Show, false),
                value: 'Additional Service',
            },
            {
                order: 2, //findSettingsItem(findSettings(getAccountDocSettingVariables(accountBillingProfile), 'ShowAdditionalServicesQty'), null, 'sortOrder'),
                show: getAccountDocSettingItem(accountBillingProfile, "ShowAdditionalServicesQty", AccountDocSettingVariables.Show, false),
                value: 'Qty',
            },
            {
                order: 3, //findSettingsItem(findSettings(getAccountDocSettingVariables(accountBillingProfile), 'ShowAdditionalServicesRate'), null, 'sortOrder'),
                show: getAccountDocSettingItem(accountBillingProfile, "ShowAdditionalServicesRate", AccountDocSettingVariables.Show, false),
                value: 'Rate',
            },
            {
                order: 4, //findSettingsItem(findSettings(getAccountDocSettingVariables(accountBillingProfile), 'ShowAdditionalServicesPrice'), null, 'sortOrder'),
                show: getAccountDocSettingItem(accountBillingProfile, "ShowAdditionalServicesPrice", AccountDocSettingVariables.Show, false),
                value: 'Price',
            },
        ];
        dataSourceTableHeadAdditional = dataSourceTableHeadAdditional.sort((a: any, b: any) => a.order - b.order);

        let dataSourceTableBodyAdditional: any = [];
        let additionalItems = proformaPricings && (proformaPricings.filter((x: any) => x.serviceType === ServiceType.AdditionalService).length > 0) ? proformaPricings.filter((x: any) => x.serviceType === ServiceType.AdditionalService) : [];
        if(additionalItems && additionalItems.length > 0){
            additionalItems.forEach((item: any) => {
                let dataSourceTableBodyRowAdditional: any = [
                    {
                        order: 1, //findSettingsItem(findSettings(getAccountDocSettingVariables(accountBillingProfile), 'ShowAdditionalServicesDescription'), null, 'sortOrder'),
                        show: getAccountDocSettingItem(accountBillingProfile, "ShowAdditionalServicesDescription", AccountDocSettingVariables.Show, false),
                        value: item?.serviceTag,
                    },
                    {
                        order: 2, //findSettingsItem(findSettings(getAccountDocSettingVariables(accountBillingProfile), 'ShowAdditionalServicesQty'), null, 'sortOrder'),
                        show: getAccountDocSettingItem(accountBillingProfile, "ShowAdditionalServicesQty", AccountDocSettingVariables.Show, false),
                        value: item?.quantity,
                    },
                    {
                        order: 3, //findSettingsItem(findSettings(getAccountDocSettingVariables(accountBillingProfile), 'ShowAdditionalServicesRate'), null, 'sortOrder'),
                        show: getAccountDocSettingItem(accountBillingProfile, "ShowAdditionalServicesRate", AccountDocSettingVariables.Show, false),
                        value: getCurrency() + formatNumber(item?.price),
                    },
                    {
                        order: 4, //findSettingsItem(findSettings(getAccountDocSettingVariables(accountBillingProfile), 'ShowAdditionalServicesPrice'), null, 'sortOrder'),
                        show: getAccountDocSettingItem(accountBillingProfile, "ShowAdditionalServicesPrice", AccountDocSettingVariables.Show, false),
                        value: getCurrency() + formatNumber((item?.quantity * item?.price)),
                    },
                ];
                dataSourceTableBodyRowAdditional = dataSourceTableBodyRowAdditional.sort((a: any, b: any) => a.order - b.order);
                dataSourceTableBodyAdditional.push(dataSourceTableBodyRowAdditional);
            });
        }
        /* END ADDITIONAL ITEMS */

        let totalObj = getTotal(form, proformaPricings, 'proformaPricings');
        let subtotal = totalObj?.subtotal;
        let totalGST = totalObj?.totalGST;
        let total = totalObj?.total;
        let paymentReceived = totalObj?.paymentReceived;
        let balance = totalObj?.balance;
        

        return <Row className='g-12 align-items-center'>
            <Col xs={true}>
                {getAccountDocSettingItemProformaInvoice(
                    accountBillingProfile,
                    "ShowProformaInvoice",
                    AccountDocSettingVariables.Show,
                    false
                ) && <span className='fs-20 semibold gray-900'>
                    {stringToHtmlTrim(getAccountDocSettingItemProformaInvoice(
                        accountBillingProfile,
                        "LabelPROFORMA_INVOICE",
                        AccountDocSettingVariables.Label,
                        ""
                    ))}
                </span>}
            </Col>
            <Col xs={'auto'} className='text-end'>
                <StyledBadge bg="secondary" status={form?.proformaInvoiceStatus} pill>{proformaInvoiceStatusText(form?.proformaInvoiceStatus, total, form?.proformaPaymentReceived)}</StyledBadge>
            </Col>

            <Col xs={12} className='py-8 px-12 py-8 mt-0'>
                <Row className='gx-12 py-8 px-10 align-items-center' style={{ borderRadius: '6px', backgroundColor: 'var(--bs-blue-focus1)' }}>
                    <Col xs={'auto'} className='fs-12 medium gray-700'>
                        {getAccountDocSettingItemProformaInvoice(
                            accountBillingProfile,
                            "ShowProformaInvoice",
                            AccountDocSettingVariables.Show,
                            false
                        ) && <>
                            {stringToHtmlTrim(getAccountDocSettingItemProformaInvoice(
                                accountBillingProfile,
                                "LabelPROFORMA_INVOICE",
                                AccountDocSettingVariables.Label,
                                ""
                            ))}
                        </>}
                    </Col>
                    <Col xs={true} className='fs-12 medium gray-900'>{(form && form?.proformaInvoiceNumber && form?.proformaInvoiceNumber != '') ? form?.proformaInvoiceNumber : 'PENDING'}</Col>
                    {(form && form.proformaInvoiceDate && form.proformaInvoiceDate != '') && <Col xs={'auto'} className='text-end'>
                        <span className='fs-12 medium gray-700'>Date: </span>
                        <span className='fs-12 medium gray-900'>{moment(form.proformaInvoiceDate, dateFormat()).format('DD-MMM-yyyy')}</span>
                    </Col>}
                </Row>
            </Col>


            <Col xs={12}>
                <StyledList
                    size="small"
                    bordered
                    dataSource={dataSourceList}
                    renderItem={(item: any) => {
                        if(item.show){
                            return <List.Item>
                                <Row className='g-16 w-100'>
                                    <Col xs={3} className='fs-11 medium gray-700'>{item?.label}</Col>
                                    <Col xs={'auto'} className='fs-11 medium gray-700'>:</Col>
                                    <Col xs={true} className='fs-12 regular gray-900'>{item?.value}</Col>
                                </Row>
                            </List.Item>
                        }
                    }}
                />
            </Col>


            {(dataSourceTableBodyStandard && dataSourceTableBodyStandard.length > 0) && <>
                <Col xs={12} className='mt-24'>
                    <StyledTable>
                        <thead>
                            <tr>
                                <th>No</th>
                                {dataSourceTableHeadStandard.map((item: any, index: number) => {
                                    return <th key={'printpreview_standard_head_item_' + index}>{item.value}</th>
                                })}
                            </tr>
                        </thead>
                        <tbody>
                            {dataSourceTableBodyStandard.map((row: any, rowIndex: number) => {
                                return <tr key={'printpreview_standard_body_row_' + rowIndex}>
                                    <td>{rowIndex+1}</td>
                                    {row.map((item: any, index: number) => {
                                        return <td key={'printpreview_standard_body_row'  + rowIndex + '_Item_' + index}>{item.value}</td>
                                    })}
                                </tr>
                            })}
                        </tbody>
                    </StyledTable>
                </Col>
            </>}

            {(dataSourceTableBodyAdditional && dataSourceTableBodyAdditional.length > 0) && <>
                <Col xs={12} className='mt-24'>
                    <StyledTable>
                        <thead>
                            <tr>
                                <th>No</th>
                                {dataSourceTableHeadAdditional.map((item: any, index: number) => {
                                    return <th key={'printpreview_additional_head_item_' + index}>{item.value}</th>
                                })}
                            </tr>
                        </thead>
                        <tbody>
                            {dataSourceTableBodyAdditional.map((row: any, rowIndex: number) => {
                                return <tr key={'printpreview_additional_body_row_' + rowIndex}>
                                    <td>{rowIndex+1}</td>
                                    {row.map((item: any, index: number) => {
                                        return <td key={'printpreview_additional_body_row'  + rowIndex + '_Item_' + index}>{item.value}</td>
                                    })}
                                </tr>
                            })}
                        </tbody>
                    </StyledTable>
                </Col>
            </>}

            <Col xs={12} className='mt-24'>
                <Row className='g-8'>
                    <Col xs={{ span: 12, order: 2 }} lg={{ span: 6, order: 1 }} className={'mt-24 mt-lg-8'}>
                        {getAccountDocSettingItemProformaInvoice(
                            accountBillingProfile,
                            "ShowMessageToCustomer",
                            AccountDocSettingVariables.Show,
                            false
                        ) && <div className='rich-text-parse-texts' style={{ padding: '12px', lineHeight: '2px', borderRadius: '6px', backgroundColor: (stringToHtmlTrim(getAccountDocSettingItemProformaInvoice(accountBillingProfile, "StringMessageToCustomer", AccountDocSettingVariables.String, "") != '') ? 'var(--bs-blue-focus1)' : 'transparent') }}>
                            {stringToHtmlTrim(getAccountDocSettingItemProformaInvoice(
                                accountBillingProfile,
                                "StringMessageToCustomer",
                                AccountDocSettingVariables.String,
                                ""
                            ))}
                        </div>}
                    </Col>
                    <Col xs={{ span: 12, order: 1, offset: 0 }} sm={{ span: 6, order: 1, offset: 6 }} lg={{ span: 5, order: 2, offset: 1 }}>
                        <StyledTotal className='gx-0 mt-s1'>
                            <Col xs={12}>
                                <Row>
                                    <Col xs={6} className='fs-12 regular gray-900'>{totalFields.subtotal.label}</Col>
                                    <Col xs={6} className='fs-12 regular gray-900'>{getCurrency() + formatNumber(subtotal)}</Col>
                                </Row>
                            </Col>
                            <Col xs={12}>
                                <Row>
                                    <Col xs={6} className='fs-12 regular gray-900'>{totalFields.GSTTotal.label}</Col>
                                    <Col xs={6} className='fs-12 regular gray-900'>{getCurrency() + formatNumber(totalGST)}</Col>
                                </Row>
                            </Col>
                            <Col xs={12}>
                                <Row>
                                    <Col xs={6} className='fs-12 semibold gray-900'>{totalFields.total.label}</Col>
                                    <Col xs={6} className='fs-12 semibold gray-900'>{getCurrency() + formatNumber(total)}</Col>
                                </Row>
                            </Col>
                        </StyledTotal>

                        {(form && form?.proformaInvoiceNumber && form?.proformaInvoiceNumber != '') && <>
                            <StyledTotal className='gx-0 mt-8'>
                                <Col xs={12}>
                                    <Row>
                                        <Col xs={6} className='fs-12 regular gray-900'>{totalFields.paymentReceived.label}</Col>
                                        <Col xs={6} className='fs-12 regular gray-900'>{getCurrency() + formatNumber(paymentReceived)}</Col>
                                    </Row>
                                </Col>
                                <Col xs={12}>
                                    <Row>
                                        <Col xs={6} className='fs-12 semibold gray-900'>{totalFields.balance.label}</Col>
                                        <Col xs={6} className='fs-12 semibold gray-900'>{getCurrency() + formatNumber(balance)}</Col>
                                    </Row>
                                </Col>
                            </StyledTotal>
                        </>}
                    </Col>
                </Row>
            </Col>
            
            {/* <Col xs={12} className='mt-24 mb-100'>
                <Row className='g-8'>
                    <Col xs={12}>Accept this Proforma Invoice by clicking “Accept” button below:</Col>
                    <Col xs={12}>
                        <StyledButton>ACCEPT</StyledButton>
                    </Col>
                </Row>
            </Col> */}
        </Row>
    }
    /* END PAGES */


    /* LAYOUT */
    const page1Elements = () => {
        return <div className='page'>
            <Row className='g-24 align-items-center'>
                <Col xs={12}>{headerDefaultElements()}</Col>
                <Col xs={12}>{page1()}</Col>
                <Col xs={12}>{footerElements()}</Col>
            </Row>
        </div>
    }
    /* END LAYOUT */


    const previewElements = () => {
        return <div className='wrapper'>
            {page1Elements()}
        </div>
    }


    return <>
        {previewElements()}
    </>
}

export default PreviewComponent;
